<template>
  <div class="search-block">
    <h4 class="search-block-title">{{ title }}</h4>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'SearchBlock',
    props: {
      title: {
        type: String,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .search-block {
    padding: @size-extra-medium 0;
    border-bottom: @border-base;
  }

  .search-block-title {
    margin: 0 0 @size-base;
    font-size: @font-size-base;
    font-weight: @font-weight-strong;
    line-height: 1;
  }
</style>
